module.exports = __webpack_public_path__ + "img/26.4a3c1286.jpg";